import React, { useState, useEffect } from "react";

interface SelectInputProps {
  label: string;
  options: string[];
  selectedValue?: string; // Ensure this is named 'selectedValue' in the props interface
  onChange?: (value: string) => void;
}

const SelectInput: React.FC<SelectInputProps> = ({
  label,
  options,
  selectedValue,
  onChange,
}) => {
  const [value, setValue] = useState(selectedValue || options[0]);

  // Sync local state with selectedValue if it changes externally
  useEffect(() => {
    if (selectedValue !== undefined) {
      setValue(selectedValue);
    }
  }, [selectedValue]);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setValue(e.target.value);
    onChange && onChange(e.target.value);
  };

  return (
    <div>
      <label className="block mb-2 text-sm text-lightgray-200">{label}</label>
      <select
        value={value}
        onChange={handleChange}
        className="block w-full border-none p-4 rounded-lg bg-lightblue-100 text-sm text-grease-100 placeholder-gray-400 focus:outline-none"
      >
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectInput;
